import React from 'react';

import { Box } from '@mui/material';

import type { FormProperties } from './Form.types';

export const Form: React.FC<FormProperties> = ({
  dataTest = 'form',
  children,
  sx,
  name,
  onSubmit,
  noValidate,
  id,
}) => {
  return (
    <Box
      data-testid={dataTest}
      id={id}
      component='form'
      sx={sx}
      name={name}
      onSubmit={onSubmit}
      noValidate={noValidate}
    >
      {children}
    </Box>
  );
};
